import { createAction, props } from '@ngrx/store';
// Interfaces
import { IApplication } from '@shared/interfaces/applications.interface';

// Listar Usuarios action
export const LOAD_APPS = createAction('[APPLICATONS] Cargar Lista de Aplicaciones');

// Devuelve los datos de los cargos si se obtuvieron correctamente
export const LOAD_APPS_SUCCESS = createAction(
  '[APPLICATONS] Listar Aplicaciones Success',
  props<{ applications: IApplication[] }>(),
);

// Devuelve el error si no se logran obtener los cargos
export const LOAD_APPS_ERROR = createAction('[APPLICATONS] Listar Aplicaciones Error', props<{ payload: any }>());
